import { ArrowCircleLeft, Edit, PersonAdd } from "@mui/icons-material";
import { Avatar, Button, Chip, FormControl, InputLabel, MenuItem, Paper, Select, Tooltip, Typography, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import { ChannelDto } from "../../types/channel";
import { ProfileDto } from "../../types/UserToken";
import { ChannelMemberDto } from "../../types/channelMember";

interface HeaderMessageBodyProps {
  channelInfo: ChannelDto | null;
  isGlobal: boolean;
  currentUser: ProfileDto;
  handleShowChats: () => void;
  setOpenChannelDetails: (open: boolean) => void;
  setEditDialogOpen: (open: boolean) => void;
  getChannelTitle: () => string;
  getChannelIcon: () => JSX.Element | null;
  IsActiveMember: boolean;
  filter: string;
  setFilter: (filter: string) => void;
  isAdmin: boolean;
  channel: ChannelDto | null;
  channelMembers: ChannelMemberDto[];
  setMembersDialogOpen: (open: boolean) => void;
}

export const HeaderMessageBody = ({
  channelInfo,
  isGlobal,
  currentUser,
  handleShowChats,
  setOpenChannelDetails,
  setEditDialogOpen,
  getChannelTitle,
  getChannelIcon,
  IsActiveMember,
  filter,
  setFilter,
  isAdmin,
  channel,
  channelMembers,
  setMembersDialogOpen
}: HeaderMessageBodyProps) => {
  return (
    <Paper
        elevation={0}
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: 0,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Tooltip title="Volver">
            <IconButton
              sx={{
                color: "#308a46",
                display: { xs: "flex", md: "none" },
              }}
              onClick={handleShowChats}
            >
              <ArrowCircleLeft sx={{ fontSize: 30, color: "#308a46" }} />
            </IconButton>
          </Tooltip>
          {channelInfo?.imageUrl && !isGlobal && (
            <Avatar
              src={
                channelInfo.imageUrl
                  ? channelInfo.imageUrl
                  : "assets/images/profilePicture.png"
              }
              alt={channelInfo.name}
              sx={{
                borderRadius: "50%",
                objectFit: "fill",
                width: { xs: 50, md: 70 },
                height: { xs: 50, md: 70 },
              }}
            />
          )}
          {getChannelIcon()}
          <Box>
            {isGlobal ? (
              <Typography
                variant="h6"
                component="div"
                sx={{ fontWeight: 600, fontSize: { xs: "13px", md: "19px" } }}
              >
                Chat Online
              </Typography>
            ) : IsActiveMember ? (
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "13px", md: "19px", cursor: "pointer" },
                }}
                onClick={() => setOpenChannelDetails(true)}
              >
                {getChannelTitle()}
              </Typography>
            ) : (
              <Typography
                variant="h6"
                component="div"
                sx={{ fontWeight: 600, fontSize: { xs: "13px", md: "19px" } }}
              >
                {getChannelTitle()}
              </Typography>
            )}
          </Box>
          {!isGlobal && channelInfo?.createdByProfileId === currentUser.id && (
            <IconButton
              onClick={() => setEditDialogOpen(true)}
              sx={{ cursor: "pointer" }}
            >
              <Edit sx={{ color: "primary", fontSize: { xs: 20, md: 25 } }} />
            </IconButton>
          )}
          {isGlobal && (
            <>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: { xs: "10px", md: "14px" } }}
              >
                Conversaciones abiertas para toda la comunidad
              </Typography>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="message-filter-label">Filtrar</InputLabel>
                <Select
                  labelId="message-filter-label"
                  id="message-filter"
                  value={filter}
                  label="Filtrar"
                  onChange={(e) => setFilter(e.target.value)}
                >
                  <MenuItem value="all">Todos</MenuItem>
                  <MenuItem value="today">Hoy</MenuItem>
                  <MenuItem value="yesterday">Ayer</MenuItem>
                  <MenuItem value="week">Última semana</MenuItem>
                  <MenuItem value="month">Último mes</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </Box>

        {channel && !isGlobal && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Chip
              label={`${channelMembers.length} miembros`}
              size="small"
              variant="outlined"
              sx={{
                borderRadius: 2,
                fontSize: { xs: "10px", md: "12px" },
                display: { xs: "none", md: "flex" },
              }}
            />
            {isAdmin && (
              <Tooltip title="Invitar miembros" arrow>
                <Button
                  size="small"
                  onClick={() => setMembersDialogOpen(true)}
                  startIcon={<PersonAdd />}
                  disabled={!IsActiveMember}
                  sx={{
                    borderRadius: 2,
                    fontSize: { xs: "8px", md: "12px" },
                    color: "#308a46",
                    "&:hover": { color: "#307a46" },
                    ":disabled": { opacity: 0.5 },
                  }}
                ></Button>
              </Tooltip>
            )}
          </Box>
        )}
      </Paper>
  );
};
